export { default as WorkbenchNotesConfigComponent } from './workbench-notes-config.component';